import React from 'react';
import {DateInput} from 'semantic-ui-calendar-react';
import moment, {ISO_8601} from 'moment';

const format = 'l';
const localization = document.getElementById('userLang')?.getAttribute('data-param') ?? 'fi';

moment.locale(localization);

/**
 * Wrapper for DateInput.
 *
 * @param props
 * @returns {JSX.Element}
 */
function DatePicker(props) {
    let {value, ...rest} = props;

    if (value) {
        const date = moment(`${value}Z`, ISO_8601);

        if (date.isValid()) {
            value = date.format(format);
        }
    }

    return <DateInput
        localization={localization}
        popupPosition="top center"
        animation="none"
        closable={true}
        clearable={true}
        initialDate={moment()}
        dateFormat={format}
        closeOnMouseLeave={false}
        value={value}
        {...rest}
        onClear={(e, a) => {
            if (typeof props.onClear === 'function') {
                props.onClear();
            }

            if (typeof props.onChange === 'function') {
                props.onChange(e, a);
            }
        }}
        onChange={(e, a) => {
            if (typeof props.onChange === 'function') {
                props.onChange(e, a);
            }
        }}
    />;
}

export default DatePicker;